/* Copyright 2021, Milkdown by Mirone. */
import { remarkPluginFactory } from '@milkdown/core';
import links from 'remark-inline-links';
const isParent = (node) => !!node.children;
const isHTML = (node) => node.type === 'html';
function flatMapWithDepth(ast, fn) {
    return transform(ast, 0, null)[0];
    function transform(node, index, parent) {
        if (isParent(node)) {
            const out = [];
            for (let i = 0, n = node.children.length; i < n; i++) {
                const xs = transform(node.children[i], i, node);
                if (xs) {
                    for (let j = 0, m = xs.length; j < m; j++) {
                        out.push(xs[j]);
                    }
                }
            }
            node.children = out;
        }
        return fn(node, index, parent);
    }
}
const filterHTMLPlugin = () => {
    function transformer(tree) {
        flatMapWithDepth(tree, (node) => {
            if (!isHTML(node)) {
                return [node];
            }
            return [];
        });
    }
    return transformer;
};
export const commonmarkPlugins = [remarkPluginFactory([links, filterHTMLPlugin])];
//# sourceMappingURL=index.js.map